import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import jN from "../Dashboard/MobileDashboard/MobileDashboard.module.css";
import NoRecordFound from "../../components/NoRecordFound";

export default function WalletDashboard() {
  const navigate = useNavigate();

  const [transactions, setTransactions] = useState([]);
  const [accountDetails, setAccountDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const showError = (msg) => alert(msg);

  const fetchTransactions = async (page = currentPage, pageSize = 10) => {
    try {
      const res = await axiosInstance.get("/shop/wallet/transactions", {
        params: { page, pageSize },
      });
      setTransactions(res.data.data.data);
      setPagination(res.data.data.pagination);
      return res.data.data.wallet_info;
    } catch (err) {
      showError(err?.response?.data?.message || "Unable to fetch wallet transactions.");
      return {};
    }
  };

  const fetchWalletBalance = async () => {
    try {
      const res = await axiosInstance.get("/shop/wallet/card?period=today");
      return res.data.data.balance;
    } catch (err) {
      showError(err?.response?.data?.message || "Unable to fetch wallet summary.");
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [walletInfo, balance] = await Promise.all([
        fetchTransactions(),
        fetchWalletBalance(),
      ]);

      setAccountDetails({
        store_account_name: walletInfo.store_account_name || "N/A",
        store_account_number: walletInfo.store_account_number || "N/A",
        wallet_balance:
          typeof balance === "object" && balance?.$numberDecimal
            ? balance.$numberDecimal
            : typeof balance === "string" || typeof balance === "number"
            ? String(balance)
            : "0",
      });

      setLoading(false);
    })();
  }, [currentPage]);

  return (
    <div style={{ background: "#fff", minHeight: "100vh", fontFamily: "Plus Jakarta Sans, sans-serif", maxWidth: 430, margin: "0 auto" }}>
     
      <div style={{ padding: "0 18px", textAlign: "left" }}>
        <div style={{ fontWeight: 700, fontSize: 28, color: "#222" }}>Wallet</div>

        <p style={{ color: "#757575", fontSize: 14, textAlign: "left" }}>Check Balance / Withdraw Money</p>
      </div>

      <div className={`${jN["dashboard-card"]} ${jN["account-details-card"]}`} style={{ margin: "18px", marginTop:0,  border: "1px solid #E0E0E0", borderRadius: 10 }}>
        {loading ? (
          <>
            <div className={jN["card-left-column"]}>
              <div className={`${jN['placeholder-balance']} ${jN.shimmer}`} />
              <div className={`${jN['placeholder-label']} ${jN.shimmer}`} />
              <div className={`${jN['placeholder-button']} ${jN.shimmer}`} />
            </div>
            <div className={jN["card-right-column"]}>
              <div className={`${jN['placeholder-label']} ${jN.shimmer}`} />
              <div className={`${jN['placeholder-account-name']} ${jN.shimmer}`} />
              <div className={`${jN['placeholder-account-number']} ${jN.shimmer}`} />
            </div>
          </>
        ) : (
          <>
            <div className={jN["card-left-column"]}>
              <h3 className={jN["balance-amount"]}>
                ₦ {accountDetails.wallet_balance ? Number(accountDetails.wallet_balance).toLocaleString() : "0"}
              </h3>
              <p className={jN["account-info-label"]}>Your Balance</p>
              <button className={jN["withdraw-button"]} onClick={() => navigate("/app/wallet/withdraw-fund")}>
                Withdraw
              </button>
            </div>
            <div className={jN["card-right-column"]}>
              <p className={jN["account-info-label"]}>Account Details</p>
              {(accountDetails.store_account_name && accountDetails.store_account_name !== 'N/A' && accountDetails.store_account_name !== 'undefined') ? (
                <>
                  <p className={jN["account-info-value1"]}>{accountDetails.store_account_name}</p>
                  <p className={jN["account-info-value"]}>
                    {(accountDetails.store_account_number && accountDetails.store_account_number !== 'N/A' && accountDetails.store_account_number !== 'undefined') ? accountDetails.store_account_number : "N/A"}
                  </p>
                </>
              ) : (
                <button className={jN["add-wallet-button"]} onClick={() => navigate("/app/profile?edit=1&bank=1")}>Add Wallet</button>
              )}
            </div>
          </>
        )}
      </div>

      <div style={{ padding: "20px 18px" }}>
        <div style={{ fontWeight: 700, fontSize: 22, color: "#222" }}>Recent Transactions</div>

        <p style={{ color: "#757575", fontSize: 14, textAlign: "left !important" }}>Your transaction history</p>
      </div>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
          <CircularProgress sx={{ color: "#af3585" }} />
        </div>
      ) : transactions.length > 0 ? (
        <div style={{ marginTop: 18 }}>
          {transactions.map((tx, i) => (
            <div key={tx._id || i} style={{ display: "flex", alignItems: "center", padding: "12px 18px", borderBottom: "1px solid #F0F0F0" }}>
              <div style={{ width: 44, height: 44, borderRadius: "50%", background: tx.transaction_action === "income" ? "#1DC100" : "#F44336", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 18 }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d={tx.transaction_action === "income" ? "M12 19V5M12 19l-7-7M12 19l7-7" : "M12 5v14M12 5l7 7M12 5l-7 7"}
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 15, color: "#222" }}>
                  {tx.transaction_action?.replace(/_/g, " ").split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")}
                </div>
                <div style={{ color: "#757575", fontSize: 14 }}>{tx.transaction_id || "N/A"}</div>
                <div style={{ color: "#757575", fontSize: 14 }}>{tx.store_name || tx.destination_account || "N/A"}</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontWeight: 700, fontSize: 18, color: "#222" }}>
                  ₦ {Number(tx.amount?.$numberDecimal || tx.amount || 0).toLocaleString()}
                </div>
                <div style={{ color: "#757575", fontSize: 14 }}>{new Date(tx.createdAt).toLocaleDateString()}</div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ marginTop: 15 }}><NoRecordFound message="No transactions found." /></div>
      )}
    </div>
  );
}
